import authSelector from 'modules/Auth/selectors'
import RuleEngine from 'modules/RuleEngine/index'
import ruleSelector from 'modules/RuleEngine/selectors'
import { connect } from 'react-redux'

import {
  degreeStreamMap,
  deleteRule,
  getRolesListData,
  getRuleEngine,
  getRuleSetData,
  setUpNewRules,
  updateRuleEngine,
} from 'modules/RuleEngine/action'
import selectors from '../selectors'

const mapStateToProps = state => ({
  rolesList: ruleSelector.getRolesList(state),
  rules: ruleSelector.getRuleEngine(state),
  corporatesList: ruleSelector.getCorpList(state),
  permissions: authSelector.getUserPermissions(state),
  ruleSet: ruleSelector.getRuleSetData(state),
  instituteCampusId: state.auth.instituteDetails.id,
  rulesDegreesMetrics: selectors.getRulesDegreesMetrics(state),
  ruleDegreeStreamMap: selectors.getRuleStreamMap(state),
})

const mapDispatchToProps = {
  getRolesListData,
  updateRuleEngine,
  getRuleEngine,
  getRuleSetData,
  setUpNewRules,
  deleteRule,
  degreeStreamMap,
}

export default connect(mapStateToProps, mapDispatchToProps)(RuleEngine)
